import { render, staticRenderFns } from "./ArticleDetailBox.vue?vue&type=template&id=4c7d751e"
import script from "./ArticleDetailBox.vue?vue&type=script&lang=js"
export * from "./ArticleDetailBox.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetailBox.vue?vue&type=style&index=0&id=4c7d751e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports